if (!customElements.get('sticky-notes-modal')) {
  customElements.define(
    'sticky-notes-modal',
    class StickyNotesModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[role="dialog"]');
        this.opener = null;
        this.scrollY = 0;

        this.querySelectorAll('[data-sticky-notes-close]').forEach((element) => {
          element.addEventListener('click', () => this.close());
        });

        const backdrop = this.querySelector('[data-sticky-notes-backdrop]');
        if (backdrop) backdrop.addEventListener('click', () => this.close());

        const confirmButton = this.querySelector('[data-sticky-notes-confirm]');
        if (confirmButton) confirmButton.addEventListener('click', () => this.close({ scrollToOpener: true }));

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'Escape' || event.key === 'Esc') {
            this.close();
          } else if (event.key === 'Tab') {
            this.trapTabKey(event);
          }
        });
      }

      connectedCallback() {
        document.querySelectorAll('[data-sticky-notes-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.open(trigger));
        });
      }

      get prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      getFocusableElements() {
        return Array.from(
          this.dialog.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => element.offsetParent !== null);
      }

      trapTabKey(event) {
        const focusable = this.getFocusableElements();
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      open(trigger) {
        if (trigger) this.opener = trigger;
        this.lockScroll();
        this.setAttribute('open', '');
        this.dialog.focus();
      }

      close({ scrollToOpener = false } = {}) {
        if (!this.hasAttribute('open')) return;
        this.removeAttribute('open');
        this.unlockScroll();

        const opener = this.opener;
        if (!opener) return;

        opener.focus();
        if (scrollToOpener) {
          opener.scrollIntoView({
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
            block: 'center',
          });
        }
      }

      lockScroll() {
        this.scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }

      unlockScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, this.scrollY);
      }
    }
  );
}
